<template>
	<app>
		<flow-node :node="nodeList" :current="currentNode" :reject="rejectNode"></flow-node>
		<c-detail>
			<c-detail-item label="项目名称">
				{{detailInfo.project_name}}
			</c-detail-item>
			<c-detail-item label="项目编号">
				{{detailInfo.project_code}}
			</c-detail-item>
			<c-detail-item label="监理单位">
				{{detailInfo.jldw_name}}
			</c-detail-item>
			<c-detail-item label="业主单位">
				{{detailInfo.yzdw_name}}
			</c-detail-item>
			<c-detail-item label="施工建设地址">
				{{detailInfo.xm_address}}
			</c-detail-item>
			<c-detail-item label="企业名称">
				{{detailInfo.zbqy_name}}
			</c-detail-item>
			<c-detail-item label="企业联系人">
				{{detailInfo.zbqy_fr_name}}<span v-if="detailInfo.zbqy_phone">（{{detailInfo.zbqy_phone}}）</span>
			</c-detail-item>
			<c-detail-item label="营业执照">
				<c-media :src="detailInfo.yyzz_path"></c-media>
			</c-detail-item>
			<c-detail-item label="法人身份证头像面">
				<c-media :src="detailInfo.frsfztx_path"></c-media>
			</c-detail-item>
			<c-detail-item label="资质证书">
				<c-media :src="detailInfo.zzzs_path"></c-media>
			</c-detail-item>
			<c-detail-item label="法人身份证国徽面">
				<c-media :src="detailInfo.frsfzgh_path"></c-media>
			</c-detail-item>
			<c-detail-item label="中标通知书">
				<c-file :src="detailInfo.zb_path"></c-file>
			</c-detail-item>
			<c-detail-item label="施工方案">
				<c-file :src="detailInfo.sgfa_path"></c-file>
			</c-detail-item>
			<c-detail-item label="其他文件">
				<c-file :src="detailInfo.other_path"></c-file>
			</c-detail-item>
			<c-detail-item label="备注说明">
				{{detailInfo.remark}}
			</c-detail-item>
		</c-detail>
		
		<c-title>项目关联保函</c-title>
		<c-detail>
			<div slot="custom">
				<detail-card v-for="(item, i) in insuranceList" :key="i">
					<div class="name flex-between-center">
						<div>{{item.bx_type_name}}</div>
						<div class="state" :style="{'color': insuranceState[item.state].color}">
							<i class="tf" style="margin-right: .3em;">{{insuranceState[item.state].icon}}</i>{{insuranceState[item.state].name}}
						</div>
					</div>
					<button-group v-if="item.state == 0 && power('7')">
						<c-button @click="navigateTo('/insurance_select', {projectId: id, type: item.bx_type_id})">我要办理</c-button>
					</button-group>
					<div v-else>
						<div class="info">被保险人：{{item.bbxr_name}}</div>
						<div class="info">保险额度：<span v-if="item.bd_money">{{item.bd_money}}元</span></div>
						<div v-if="item.bx_bd_state_date" class="info">保单有效期：{{item.bx_bd_state_date}} - {{item.bx_bd_end_date}}</div>
						<div v-if="item.bx_bd_state_date" class="info">
							距离保单过期：<span v-if="item.exp_date >= 0" style="color: #f00;">还有{{item.exp_date}}天</span>
							<span v-else style="color: #f00;">已过期</span>
						</div>
					</div>
				</detail-card>
			</div>
		</c-detail>
		
		<c-title>开工令</c-title>
		<c-detail>
			<div slot="custom">
				<detail-card v-for="(item, i) in proceedList" :key="i">
					<c-file :src="item.kgl_path"></c-file>
					<div class="info">上传时间：{{item.jl_check_date}}</div>
				</detail-card>
			</div>
		</c-detail>
		
		<c-title>审批流程</c-title>
		<c-detail>
			<timeline slot="custom" :data="timeline"></timeline>
		</c-detail>
		
		<button-group slot="foot">
			<c-button v-if="resubmitButton" @click="navigateTo('/proceed_apply', {id})">重新编辑</c-button>
			<div v-if="approveButton" class="flex-center">
				<c-button color="green" @click="$refs.approve.resolve()">审批通过</c-button>
				<c-button color="red" @click="$refs.approve.reject()">驳回</c-button>
			</div>
		</button-group>
		
		<approve ref="approve" @resolve="approveHandle">
			<template v-slot="{state}">
				<c-form v-show="state">
					<c-form-item v-model="proceedFile" type="file" label="上传开工令" file-type="word,pdf,image" required></c-form-item>
				</c-form>
			</template>
		</approve>
	</app>
</template>

<script>
	import flowNode from '@/components/module/flow_node.vue'
	import underwrite from '@/components/module/underwrite.vue'
	import timeline from '@/components/module/timeline.vue'
	import approve from '@/components/module/approve.vue'
	import {mapGetters} from 'vuex'
	
	export default {
		components: {
			flowNode,
			underwrite,
			timeline,
			approve
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
				nodeList: [{
					name: '提交申请'
				}, {
					name: '(监理方)审批'
				}, {
					name: '(业主方)审批'
				}, {
					name: '办理完结'
				}],
				detailInfo: {},
				insuranceList: [],
				proceedList: [],
				timeline: [],
				proceedFile: ''
			}
		},
		
		computed: {
			...mapGetters(['power', 'insuranceState', 'proceedState']),
			
			currentNode() {
				return this.detailInfo.state <= 3 ? this.detailInfo.state + 1 : 0;
			},
			
			rejectNode() {
				return this.detailInfo.state == 4 ? (this.detailInfo.reject_user_type == 8 ? 2 : 3) : 0;
			},
			
			resubmitButton() {
				return this.detailInfo.state == 4 && this.power('7');
			},
			
			approveButton() {
				return this.detailInfo.state == 1 && this.power('8');
			}
		},
		
		mounted() {
			this.updateDetail();
		},
		
		methods: {
			updateDetail() {
				this.request({
					url: '/project/kgl/detail',
					data: {
						kgl_id: this.id
					},
					success: data => {
						this.detailInfo = data.kglInfo;
						this.insuranceList = data.bx_list;
						this.proceedList = data.kgl_list;
						this.timeline = Array.from(data.logList, item => {
							return {
								date: item.create_date,
								content: `[${item.create_user_name}] ${item.remark}`
							}
						});
					}
				});
			},
			
			approveHandle(state, remark, stop, next) {
				stop();
				
				if (state && !this.proceedFile) {
					this.$message({
						text: '请上传开工令'
					});
					return;
				}
				
				this.request({
					url: '/project/kgl/updateStateJl',
					data: {
						kgl_id: this.id,
						state: state ? 2 : 4,
						kgl_path: this.proceedFile,
						jl_remark: remark
					},
					loading: true,
					success: data => {
						next();
						this.$message({
							text: '审批成功'
						});
						this.updateDetail();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
